import React from "react";
import { Nav } from "Common/Components/Tab/Nav";
import Tab from "Common/Components/Tab/Tab";
import Fields from "./components/Fields";
import Folders from "./components/Folders";
const Account = () => {

    return (
        <React.Fragment>
            <Tab.Container defaultActiveKey="allFieldsTab">
                <div className="mt-1 -ml-3 -mr-3 rounded-none card">
                    <div className="card-body !px-2.5 !py-3">
                        <Nav className="flex flex-wrap w-full text-sm font-medium text-center nav-tabs">
                            <Nav.Item eventKey="allFieldsTab" className="group">
                                <a href="#!" data-tab-toggle data-target="allFieldsTab" className="inline-block px-4 py-2 text-base transition-all duration-300 ease-linear rounded-t-md text-slate-500 dark:text-zink-200 border-b border-transparent group-[.active]:text-custom-500 dark:group-[.active]:text-custom-500 group-[.active]:border-b-custom-500 dark:group-[.active]:border-b-custom-500 hover:text-custom-500 dark:hover:text-custom-500 active:text-custom-500 dark:active:text-custom-500 -mb-[1px]">All Fields</a>
                            </Nav.Item>
                            <Nav.Item eventKey="folderTabs" className="group">
                                <a href="#!" data-tab-toggle data-target="folderTabs" className="inline-block px-4 py-2 text-base transition-all duration-300 ease-linear rounded-t-md text-slate-500 dark:text-zink-200 border-b border-transparent group-[.active]:text-custom-500 dark:group-[.active]:text-custom-500 group-[.active]:border-b-custom-500 dark:group-[.active]:border-b-custom-500 hover:text-custom-500 dark:hover:text-custom-500 active:text-custom-500 dark:active:text-custom-500 -mb-[1px]">Folders</a>
                            </Nav.Item>
                        </Nav>
                    </div>
                </div>
                <Tab.Content className="tab-content">
                    <Tab.Pane eventKey="allFieldsTab" id="allFieldsTab">
                        <Fields />
                    </Tab.Pane>
                    <Tab.Pane eventKey="folderTabs" id="folderTabs">
                        <Folders />
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container>
        </React.Fragment>
    );
}

export default Account;